import DetailRealisasiPPA from './DetailRealisasiPPA'

export default DetailRealisasiPPA